// extracted by mini-css-extract-plugin
export var container = "_cy-0";
export var icon = "_cy-1";
export var text = "_cy-2";